import isInteger from 'lodash/isInteger';
import isNil from 'lodash/isNil';

const MON_DAY_ID = 1;
const SUN_DAY_ID = 7;

export const getDayId = (day_id?: string): number => {
  const today = new Date();
  const day = today.getDay();
  const _dayId = day === 0 ? SUN_DAY_ID : day;
  let dayId = isNil(day_id) ? _dayId : Number(day_id);

  // 요일 정보 (1 ~ 7) 가 아닌 경우 예외 처리
  if (!isInteger(dayId) || dayId < MON_DAY_ID || dayId > SUN_DAY_ID) {
    dayId = _dayId;
  }

  return dayId;
};
